import { Checkbox, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'

import { getTranslate } from '../../localization'
import { Accommodation, BulkIdCode } from '../../types/accommodation'
import useStyles from './styles/ProviderListEachRow.styles'

interface AccommodationListEachRowProps {
  AccommodationItem: Accommodation
  setAccommodationIdCodes: React.Dispatch<React.SetStateAction<BulkIdCode[]>>
  index: number
  setFilteredAccommodationList: React.Dispatch<
    React.SetStateAction<Accommodation[]>
  >
  filteredAccommodationList: Accommodation[]
  setAccommodationList: React.Dispatch<React.SetStateAction<Accommodation[]>>
  accommodationList: Accommodation[]
}
const AccommodationListEachRow: React.FC<AccommodationListEachRowProps> = ({
  AccommodationItem,
  setAccommodationIdCodes,
  index,
  setFilteredAccommodationList,
  filteredAccommodationList,
  setAccommodationList,
  accommodationList
}) => {
  const classes = useStyles()

  const handleClickOnCheckbox = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFilteredAccommodationList([
      ...filteredAccommodationList.slice(0, index),
      {
        ...filteredAccommodationList[index],
        checked: event.target.checked
      },
      ...filteredAccommodationList.slice(index + 1)
    ])

    //
    setAccommodationList([
      ...accommodationList.slice(0, index),
      {
        ...accommodationList[index],
        checked: event.target.checked
      },
      ...accommodationList.slice(index + 1)
    ])
  }

  useEffect(() => {
    const tempPropertyCodes: BulkIdCode[] = filteredAccommodationList
      .filter((acc) => acc.checked && acc.basicDetails.accommodationID)
      .map((acc) => ({
        ID: acc.basicDetails.accommodationID as string,
        code: acc.basicDetails.propertyCode
      }))

    setAccommodationIdCodes(tempPropertyCodes)
  }, [filteredAccommodationList])

  return (
    <div className={classes.root}>
      <Checkbox
        color="primary"
        className={classes.checkbox}
        checked={AccommodationItem.checked}
        onChange={handleClickOnCheckbox}
      />
      <Typography variant="h5" className={classes.accommodationName}>
        {getTranslate(`${AccommodationItem.basicDetails.name}`)}
      </Typography>
    </div>
  )
}

export default AccommodationListEachRow
